import jsonp from 'jsonp'

const SUBSCRIBE_AUDIENCE_ID = 'e2c1e8b15c'

export type callBackObject = {
  status: string
  toast: {
    variant: 'destructive' | 'default' | null | undefined
    duration: number
    description: string | undefined
    className: string | undefined
  }
}

export async function submitEmailToList(email: string) {
  return await requestMailchimpEmbed(email)
}

export async function sendDownloadPDF(email: string, audienceId: string) {
  return await requestMailchimpEmbed(email, audienceId)
}

function resolveSubscribeUrl(email: string, audienceId?: string): string | undefined {
  let actionUrl = process.env.NEXT_PUBLIC_MAILCHIMP_ACTION ?? ''

  if (audienceId) {
    actionUrl = actionUrl.replace(`id=${SUBSCRIBE_AUDIENCE_ID}`, `id=${audienceId}`)
  }

  return `${actionUrl}&EMAIL=${encodeURIComponent(email)}`
}

async function requestMailchimpEmbed(
  email: string,
  audienceId?: string,
): Promise<any> {
  const trimmedEmail = email.trim()
  if (!trimmedEmail.includes('@')) {
    throw new Error('Invalid email')
  }

  const subscribeUrl = resolveSubscribeUrl(email, audienceId)
  if (!subscribeUrl) {
    throw new Error('Subscribe is not configured')
  }

  return fetchMailchimpEmbedSubscribe(subscribeUrl)
}


async function fetchMailchimpEmbedSubscribe(subscribeUrl: string): Promise<any> {
  const result = await new Promise<callBackObject>((resolve) => {
    jsonp(subscribeUrl, { param: 'c' }, (_, data) => {
      let toastDescription, toastClassName;
      if (data.result === "success") {
        toastDescription = 'Your request has been sent';
        toastClassName = 'bg-[#e1b12c]';
      } else if (data.type === "default") {
        toastDescription = 'custom';
        toastClassName = 'bg-[#e84118]';
      }
      const response: callBackObject = {
        status: data.result,
        toast: {
          variant: 'destructive',
          duration: 2000,
          description: toastDescription || data.msg,
          className: toastClassName
        }
      };
      resolve(response);
    })
  })
  return result;
}